<template>
  <body>
    <aside class="Blk-1">
      <img class="imagen" :src="colVista.imagen">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Sellos registrados</p>
          <select name="titSello" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="selloSel" @change.prevent="mostrarDatosSello(selloSel._id)">
            <option v-for="sello in listaSellos"
              :key="sello._id"
              :value="sello">
              {{sello.titulo}}
            </option>
          </select>
        </div>
        <form @change="cambioForm">
          <div class="Blk-Campo">
            <p>Descripción completa*</p>
            <textarea name="titulo" class="campo" ref="nombreSello" rows="2"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.titulo"
              spellcheck="false">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Valor</p>
            <input type="text" name="valor" class="campo"
              v-model.trim="colVista.valor"
              :disabled = '!habBotAndCamp.hab'>
            <p>Moneda</p>
            <input type="text" name="moneda" class="campo"
              v-model.trim="colVista.moneda"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="colVista.pais"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Año</p>
            <input type="text" name="fecha" class="campo"
              v-model.trim="colVista.anyo"
              :disabled = '!habBotAndCamp.hab'>
            <p>Tamaño</p>
            <input type="text" name="size" class="campo" placeholder="aaxAA anchoxAlto en mm"
              v-model.trim="colVista.size"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palabrasClave" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Comentarios</p>
            <textarea name="comments" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.comments">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.privado">
            </div>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" class="inputfile" @change="cargarImagen"/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar sello</p>
          </div>
          <img class="imagen2" :src="colVista.imagen">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevo"
        @editar="editar"
        @del="borrar"
        @save="save"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import axios from 'axios'
export default {
  name: 'FormSellos',
  components: { BotonesCRUD },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getListaSellos() // Trae lista de titulos de sellos sin otros datos
    this.activaModo('INI')
  },
  data () {
    return {
      selloSel: [],
      selloSelBkUp: [],
      listaSellos: [],
      colVista: {},
      colVistaBkUp: {},
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getListaSellos () {
      try {
        const url = `${this.URLbase}/sellos/listaSellos`
        const res = await fetch(url)
        this.listaSellos = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    mostrarDatosSello (IdSello) {
      this.getDatosSello(IdSello)
      this.activaModo('Sel')
    },
    async getDatosSello (IdSelecc) {
      try {
        const url = `${this.URLbase}/sellos/getSelloData`
        const selloId = { _id: IdSelecc }
        const res = await axios.post(url, selloId)
        this.colVista = res.data
      } catch (error) {
        alert(error)
      }
    },
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.selloSelBkUp = this.selloSel
        this.activaModo('EDI')
      } else {
        // Si se cancela, restaura los valores previos
        this.colVista = JSON.parse(JSON.stringify(this.colVistaBkUp))
        this.selloSel = this.selloSelBkUp
        this.activaModo('Sel')
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas && this.minData) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi && this.minData) {
        this.activaModo('EDIs')
      }
    },
    async borrar () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este sello. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/sellos/borrarSello`
          const selloId = { _id: this.colVista._id }
          axios.post(url, selloId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearColVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getListaSellos()
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },
    async save () {
      try {
        const url = `${this.URLbase}/sellos/save`
        const selloData = this.colVista
        await axios.post(url, selloData, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
            this.getListaSellos()
            this.IsModoSalirMas = false
            this.IsModoSalirEdi = false
            this.blanquearColVista()
            this.activaModo('INI')
          })
      } catch (error) {
        alert(error)
      }
    },
    nuevo () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.selloSelBkUp = JSON.parse(JSON.stringify(this.selloSel))
        this.blanquearColVista()
        this.activaModo('MAS')
        // this.setFocus()
      } else {
        this.selloSel = this.selloSelBkUp
        if (this.selloSel.titulo) {
          this.colVista = JSON.parse(JSON.stringify(this.colVistaBkUp))
          this.activaModo('Sel')
        } else {
          this.activaModo('INI')
        }
      }
    },
    blanquearColVista () {
      this.colVista = {}
      this.selloSel = []
    },
    cargarImagen (event) {
      // Asignamos la imagen a nuestra data
      const imagen = event.target.files[0]
      // Si imagen > 500kB alertamos y salimos
      const tamaño = imagen.size
      if (tamaño > 500000) {
        alert('El tamaño del archivo es: ' +
        Math.round(tamaño / 1000) +
        'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb')
      } else {
        // Cargamos la previsualización
        const reader = new FileReader()
        reader.readAsDataURL(imagen)
        reader.onload = e => { this.colVista.imagen = e.target.result }
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'Sel':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    }
  },
  computed: {
    minData () {
      return (this.colVista.titulo)
    },
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imagen{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imagen2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  /* color: darkslategray; */
  padding-top: 20px;
}
.Btns {
  padding-left: 20px;
  padding-top: 20px;
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    width:94%;
    flex-direction: column;
    align-items:stretch;
    margin-left:3%;
  }
  .Blk-Campo p{
    max-width: 80%;
  }
  .campo{
    width: 100%;
    margin: 0 0 0 0;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  textarea.campo, input.campo, div.campo{
    width: 97%;
    margin-left:0%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imagen2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
}
</style>
